import Dialog from "src/components/Dialog";
import { useTranslation } from "react-i18next";

export default function BabyCameraNotAvailableDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("parentStation.babyCameraNotAvailableDialog.heading")}
      text={t("parentStation.babyCameraNotAvailableDialog.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
